import { EnumOption } from "./enum-option"

export const ACWIAProvision = {
    InstitutionOfHigherEdu: 1,
    AffiliatedOrRelatedNonprofitEntity: 2,
    NonprofitOrGovResearchOrg: 4,
}

export const ACWIAProvisionList: EnumOption[] = [
    { value: ACWIAProvision.InstitutionOfHigherEdu, label: '(i) Institution of Higher Education' },
    { value: ACWIAProvision.AffiliatedOrRelatedNonprofitEntity, label: '(ii) Affiliated or Related Nonprofit Entity Connected or Associated with an Institution of Higher Education' },
    { value: ACWIAProvision.NonprofitOrGovResearchOrg, label: '(iii) Nonprofit Research Organization or Government Research Organization' },
]
